import { render, staticRenderFns } from "./ui-fruits-item.vue?vue&type=template&id=93f4ccd4&"
import script from "./ui-fruits-item.vue?vue&type=script&lang=js&"
export * from "./ui-fruits-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports